<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 244.8 284.8" style="enable-background:new 0 0 244.8 284.8;" xml:space="preserve">
    <g>
      <defs>
        <rect id="t2_SVGID_1_" x="65.7" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t2_SVGID_2_">
        <use xlink:href="#t2_SVGID_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            <path id="t2_SVGID_3_" d="M74.7,0h95.4c2.4,0,4.7,0.9,6.4,2.6s2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4c-1.7,1.7-4,2.6-6.4,2.6H74.7
              c-2.4,0-4.7-0.9-6.4-2.6c-1.7-1.7-2.6-4-2.6-6.4V9c0-2.4,1-4.7,2.6-6.4S72.3,0,74.7,0z"/>
          </defs>
          <clipPath id="t2_SVGID_4_">
            <use xlink:href="#t2_SVGID_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <path class="st2" d="M65.7,0h113.4v113.4H65.7V0z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t2_SVGID_5_" x="65.7" y="171.4" width="113.4" height="113.4"/>
      </defs>
      <clipPath id="t2_SVGID_6_">
        <use xlink:href="#t2_SVGID_5_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st3">
        <g>
          <defs>
            <path id="t2_SVGID_7_" d="M74.7,171.4h95.4c2.4,0,4.7,0.9,6.4,2.6c1.7,1.7,2.6,4,2.6,6.4v95.4c0,2.4-1,4.7-2.6,6.4s-4,2.6-6.4,2.6
              H74.7c-2.4,0-4.7-0.9-6.4-2.6s-2.6-4-2.6-6.4v-95.4c0-2.4,1-4.7,2.6-6.4C70,172.4,72.3,171.4,74.7,171.4z"/>
          </defs>
          <clipPath id="t2_SVGID_8_">
            <use xlink:href="#t2_SVGID_7_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st4">
            <path class="st2" d="M65.7,171.4h113.4v113.4H65.7V171.4z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t2_SVGID_9_" y="20" width="244.8" height="244.8"/>
      </defs>
      <clipPath id="t2_SVGID_10_">
        <use xlink:href="#t2_SVGID_9_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st5">
        <g>
          <defs>
            <path id="t2_SVGID_11_" d="M23,20h198.8c12.7,0,23,10.3,23,23v198.8c0,12.7-10.3,23-23,23H23c-12.7,0-23-10.3-23-23V43
              C0,30.3,10.3,20,23,20z"/>
          </defs>
          <clipPath id="t2_SVGID_12_">
            <use xlink:href="#t2_SVGID_11_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st6">
            <path class="st7" d="M0,20h244.8v244.8H0V20z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="t2_SVGID_13_" x="29.3" y="49.3" width="186.3" height="186.3"/>
      </defs>
      <clipPath id="t2_SVGID_14_">
        <use xlink:href="#t2_SVGID_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st8">
        <g>
          <defs>
            <circle id="t2_SVGID_15_" cx="122.4" cy="142.4" r="93.1"/>
          </defs>
          <clipPath id="t2_SVGID_16_">
            <use xlink:href="#t2_SVGID_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st9">
            <path class="st2" d="M29.3,49.3h186.3v186.3H29.3V49.3z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 't2'
}
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  /* fill: var(--principal); */
  /* filter: brightness(0.9); */
  }
</style>

<style scoped>
  .st0{clip-path:url(#t2_SVGID_2_);}
  .st1{clip-path:url(#t2_SVGID_4_);}
  .st2{fill:#2C6EDF;}
  .st3{clip-path:url(#t2_SVGID_6_);}
  .st4{clip-path:url(#t2_SVGID_8_);}
  .st5{clip-path:url(#t2_SVGID_10_);}
  .st6{clip-path:url(#t2_SVGID_12_);}
  .st7{fill:#85B0F9;}
  .st8{clip-path:url(#t2_SVGID_14_);}
  .st9{clip-path:url(#t2_SVGID_16_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/t2.vue